module.exports = __webpack_public_path__ + "assets/img/img_url_nongye.2a02c125.png";